<div class="payment-div" #paymentDiv [innerHTML]='paymentFormHtml'></div>
<app-navigation-layout *ngIf="paymentFormHtml" [hideMain]='true' [hideMenu]="true" [hideNavigation]="true" [hideHeader]="false">
  <span header-container>
      <h3>{{ 'Thank you for your order'| translate }}</h3>
      <p>{{ 'Please wait. You will be redirected to the payment provider site.' | translate }}</p>
  </span>
</app-navigation-layout>

<app-navigation-layout *ngIf="!paymentFormHtml">
  <div main-container class="row">
    <section class="col-md-12 pb-3">
      <section class="pb-3">

        <h3>{{ 'Payment Method' | translate }}</h3>
        <p>{{ 'Choose a form of payment:' | translate }}</p>
        <span *ngIf="!isCashPayment">
          <app-payment-providers [isVuPaymentEnabled]="isVuPayment && paymentEnabled" (eventPayStart)='onPay()'>
          </app-payment-providers>
        </span>

        <span *ngIf="isCashPayment">
          <div class="row">
            <div class="col-md-3 pb-4">
              <div class="art-box payment" [class.selected]="true">
                <div>
                  <h3>{{ 'Cash' | translate }}</h3>
                </div>
              </div>
            </div>
          </div>
        </span>
      </section>

      <section class="pb-3 app-payment-discount-placeholder">
        <app-payment-discount [showGiftCardRedeem]="showGiftCardRedeem && !isGiftCardOrder" ></app-payment-discount>
      </section>
    </section>

    <div *ngIf="showTermsConditionsLink" class="col-12 agb-message-container" [ngClass]="{'agb-message': !isVuPayment}">
      <p [ngClass]="{'agb-p': isVuPayment}">
        {{'By completing this purchase, I agree with the' | translate }} <a [ngClass]="{'link': isVuPayment}"
          (click)="showAGB()"><u>{{'AGB_LINK' | translate }}.</u></a>
      </p>
    </div>
  </div>
  <span menu-container>
    <section class="pb-3">
      <app-basket-simple-view [readonly]="basketIsReadonly"></app-basket-simple-view>
    </section>
    <section *ngIf="!isVuPayment" class="pb-3 text-lg-left text-center">
      <app-current-partner-contact></app-current-partner-contact>
    </section>
  </span>
  <span navigation-container>
    <div class="col-12">
      <app-backward-forward [backTitle]="backTitle" (backwardClick)="onBack()" [nextTitle]="nextTitle"
        (forwardClick)="onPay()" [forwardError]="" [forwardEnabled]="paymentButtonEnabled" [forwardCssClass]="' payment-button'">
      </app-backward-forward>
    </div>
  </span>
</app-navigation-layout>
